import { FunctionComponent as F, useState } from 'react';
import { Stack, Select, Typography, Container, MenuItem, Link } from '@mui/material';
import PageHeadline from '../components/UI/Text/PageHeadline';
import { Callback, FileUpload, useFileUpload } from 'use-file-upload'
import Button from '../components/UI/Button/Button';
import { getSampleProtocolsToCombineInputXlsx, postProtocolsToCombineXlsx, postXlsx } from '../core/http/protocol';

const CombineProtocols: F = () =>
{
  const [file, selectFile] = useFileUpload() as [FileUpload, ({ accept, multiple }: {
    accept: any;
    multiple: any }, callback: Callback) => void];

  const [sheets, setSheets] = useState<{ name: string, weighting: number }[]>([]);

  const handleSample = async() =>
  {
    const blob = await getSampleProtocolsToCombineInputXlsx();
    if(!blob)
      return;

    download(blob, 'InputFileSample.xlsx');
  }

  const handleUpload = async() =>
  {
    selectFile({ accept: '.xlsx', multiple: false }, async(selectedFile: FileUpload | [FileUpload]) =>
    {
      const file = (selectedFile as FileUpload)?.file;
      if(!file)
        return;
      const sheets = await postXlsx(file);
      if(!sheets)
        return;

      setSheets(sheets.sheetNames.map(name => ({ name, weighting: 1 })));
    });
  }
  const handleChangeWeighting = (weighting: number, i: number) =>
  {
    const newSheets = [...sheets];
    newSheets[i].weighting = weighting;
    setSheets(newSheets);
  }

  const handleSubmit = async() =>
  {
    if(!file || file.size > 100000)
      return;

    const blob = await postProtocolsToCombineXlsx(file.file, sheets.map(s => s.weighting))
    if(!blob)
      return;

    download(blob, 'protocols.zip');
  };

  // Create, click & remove invisible download link
  const download = (blob: Blob, filename: string) =>
  {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  return (
    <Container>
      <Stack
        direction='column'
        justifyContent='center'
        alignItems='center'
        spacing={2}>

        <PageHeadline>Combine Protocols</PageHeadline>

        <Typography>
          {"Upload .xlsx file with protocols in separate sheets (max 5)"}
        </Typography>
        <Link
          variant='body2'
          underline='hover'
          style={{ cursor: 'pointer' }}
          onClick={handleSample} >
          {"Download sample template"}
        </Link>

        <Button label='Upload' onClick={handleUpload}/>

        {file ?
          <>
            <Typography>Name: {file.name}</Typography>
            <Typography>Size: {file.size + " bytes"}</Typography>
            <Stack key={'header'} spacing={2} direction="row" sx={{ width: 500, alignItems: 'center' }}>
              <Typography variant='subtitle2' sx={{ width: '100%' }}>Sheet</Typography>
              <Typography variant='subtitle2' sx={{ width: '80px' }}>Weighting</Typography>
            </Stack>
            {sheets.map((s, i) =>
              <Stack key={i} spacing={2} direction="row" sx={{ width: 500, alignItems: 'center' }}>
                <Typography variant='body2' sx={{ width: '100%' }}>
                  {s.name}
                </Typography>
                <Select
                  size='small'
                  type='text'
                  value={s.weighting}
                  sx={{ width: '80px' }}
                  onChange={event => handleChangeWeighting(Number(event.target.value), i)}>
                  {[{ label: "1", value: 1 }, { label: "2", value: 2 }, { label: "3", value: 3 }]
                    .map((option, index) =>
                      <MenuItem key={index} dense={true} value={option.value}>{option.label}</MenuItem>)}
                </Select>
              </Stack>)}
            <Button
              label='Submit'
              onClick={handleSubmit}/>
          </> :
          <Typography>No file selected</Typography>}

      </Stack>
    </Container>);
};

export default CombineProtocols;
